import { ApiResponse, CustomQueryResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";

const SERVICE_URL = ServiceEndPoint.outbound_service;

export function recordCounts(status: string[], searchTerm: string, filterPayload: any, search_columns: any) {
  return {
    columns: [
      {
        data: "pick_ticket.pick_number",
        func: "count",
        as: "pick_count"
      }
    ],
    search_columns: search_columns,
    conditions: [...filterPayload,
      ["pick_ticket.status", "in", status]
    ],
    "search": searchTerm,
    limit: -1
  }
}


export async function fetchPickList(page?: number, payload?: any): Promise<ApiResponse<CustomQueryResponse<any>>> {
  const response = await axiosService.post(`${SERVICE_URL}pick-tickets/query`, payload);
  return response.data;
}

export async function fetchStatusWiseCounts(statuses: string[], searchTerm: string, filterPayload: any, search_columns: any): Promise<ApiResponse<any[]>> {
  const responses = await Promise.all(
    statuses.map(status =>
      axiosService.post(`${SERVICE_URL}pick-tickets/query`, recordCounts([status], searchTerm, filterPayload, search_columns))
    )
  );
  const result = responses.reduce((acc: any, response, index) => {
    acc[statuses[index]] = response.data?.data?.results[0].pick_count || 0;
    return acc;
  }, {});
  return { data: result };
}
export async function getPickDetails(id: string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}pick-tickets/${id}`);
    return response.data;
}
export async function deletePickTicketById(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}pick-tickets/${id}`);
  return response.data;
}